export const version = "random/5.0.8";
//# sourceMappingURL=_version.js.map